var map = {
	"./future/future.module": [
		"./src/app/pages/reports/future/future.module.ts",
		"future-future-module"
	],
	"./options/options.module": [
		"./src/app/pages/reports/options/options.module.ts",
		"options-options-module"
	],
	"./pages/algorithm/algorithm.module": [
		"./src/app/pages/algorithm/algorithm.module.ts",
		"pages-algorithm-algorithm-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"pages-dashboard-dashboard-module"
	],
	"./pages/data-processing/data-processing.module": [
		"./src/app/pages/data-processing/data-processing.module.ts",
		"pages-data-processing-data-processing-module"
	],
	"./pages/download/download.module": [
		"./src/app/pages/download/download.module.ts",
		"pages-download-download-module"
	],
	"./pages/dynamic-menu/dynamic-menu.module": [
		"./src/app/pages/dynamic-menu/dynamic-menu.module.ts",
		"common",
		"pages-dynamic-menu-dynamic-menu-module"
	],
	"./pages/form-controls/form-controls.module": [
		"./src/app/pages/form-controls/form-controls.module.ts",
		"pages-form-controls-form-controls-module"
	],
	"./pages/housekeeping/housekeeping.module": [
		"./src/app/pages/housekeeping/housekeeping.module.ts",
		"pages-housekeeping-housekeeping-module"
	],
	"./pages/icons/icons.module": [
		"./src/app/pages/icons/icons.module.ts",
		"pages-icons-icons-module"
	],
	"./pages/industry/industry.module": [
		"./src/app/pages/industry/industry.module.ts",
		"pages-industry-industry-module"
	],
	"./pages/landing/landing.module": [
		"./src/app/pages/landing/landing.module.ts",
		"pages-landing-landing-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/lot-change/lot-change.module": [
		"./src/app/pages/lot-change/lot-change.module.ts",
		"pages-lot-change-lot-change-module"
	],
	"./pages/market-pulse/market-pulse.module": [
		"./src/app/pages/market-pulse/market-pulse.module.ts",
		"pages-market-pulse-market-pulse-module"
	],
	"./pages/register/register.module": [
		"./src/app/pages/register/register.module.ts",
		"pages-register-register-module"
	],
	"./pages/reports/options/options.module": [
		"./src/app/pages/reports/options/options.module.ts",
		"options-options-module"
	],
	"./pages/reports/reports.module": [
		"./src/app/pages/reports/reports.module.ts",
		"pages-reports-reports-module"
	],
	"./pages/schedule/schedule.module": [
		"./src/app/pages/schedule/schedule.module.ts",
		"common",
		"pages-schedule-schedule-module"
	],
	"./pages/user-details/user-details.module": [
		"./src/app/pages/user-details/user-details.module.ts",
		"pages-user-details-user-details-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;